import {request} from '@/helpers/apiClient'
import {PRODUCT_CATEGORY_CONFIG} from '@/utils/constants/apiConfig/productCategoryConfig'

export const getProductCategoryList = async () => {
  return request(PRODUCT_CATEGORY_CONFIG.CATEGORY_LIST)
}
